import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { MessageCircle, X } from 'lucide-react';
import WhatsAppInbox from './WhatsAppInbox';
import { useBridgeAccess } from '../../hooks/useBridgeAccess';

export default function WhatsAppContactButton({ phone }: { phone?: string | null }) {
  const access = useBridgeAccess();
  const [open, setOpen] = useState(false);
  if (!access.data?.enabled || !phone) return null;
  return <>
    <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm font-medium text-green-800"><MessageCircle className="h-4 w-4" />WhatsApp</button>
    {open && <ChatDrawer phone={phone} onClose={() => setOpen(false)} />}
  </>;
}
function ChatDrawer({ phone, onClose }: { phone: string; onClose: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => { dialog.current?.showModal(); }, []);
  return createPortal(<dialog ref={dialog} aria-label="Chat WhatsApp" onCancel={onClose} onClick={e => { if (e.target === dialog.current) onClose(); }} className="fixed inset-y-0 left-auto right-0 m-0 h-[100dvh] max-h-none w-full max-w-lg border-0 p-0 shadow-2xl backdrop:bg-black/30">
    <div className="flex h-full flex-col">
      <header className="flex items-center justify-between border-b px-4 py-3"><h2 className="font-semibold">Chat WhatsApp</h2><button type="button" aria-label="Chiudi chat" onClick={onClose} className="rounded-md p-2 hover:bg-gray-100"><X className="h-5 w-5" /></button></header>
      <div className="min-h-0 flex-1"><WhatsAppInbox phone={phone} /></div>
    </div>
  </dialog>, document.body);
}
